import { render, staticRenderFns } from "./model_36.vue?vue&type=template&id=cad7f6fa&scoped=true"
import script from "./model_36.vue?vue&type=script&lang=js"
export * from "./model_36.vue?vue&type=script&lang=js"
import style0 from "./model_36.vue?vue&type=style&index=0&id=cad7f6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad7f6fa",
  null
  
)

export default component.exports